import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { environment } from '../../../environments/environment';

interface Actor {
  id: string;
  code: string;
  name: string;
}

interface Asl {
  id: number;
  code: string;
  name: string;
  cots: any[];
  wards: any[];
  uvmTypes: any[];
}

@Component({
  selector: 'app-confirm-structure',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './confirm-structure.component.html',
  styleUrl: './confirm-structure.component.scss',
})
export class ConfirmStructureComponent {
  initialOwnershipId: string | null = null;

  @Output() changeConfirmed = new EventEmitter<{ actorId: string; ownershipId: string }>();
  @Output() cancelled = new EventEmitter<void>();

  actors: Actor[] = [];
  asls: Asl[] = [];
  ownerships: any[] = [];
  filteredOwnerships: any[] = [];

  uvm: boolean = false;
  cot: boolean = false;
  ward: boolean = false;

  selectedAslId: number | null = null;
  selectedOwnershipId: any | null = null;

  searchTerm: string = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadActors();
    this.loadAsls();
  }

  loadActors(): void {
    this.http.get<Actor[]>(`${environment.beServiceUrl}/v1/actor/find`).subscribe((data) => {
      this.actors = data;
    });
  }

  loadAsls(): void {
    this.http.get<Asl[]>(`${environment.beServiceUrl}/v1/asl/find-details`).subscribe((data) => {
      this.asls = data;
    });
  }

  onAslOrActorChange(): void {
    this.selectedOwnershipId = null;
    this.loadOwnerships();
  }

  loadOwnerships(): void {
    this.ownerships = [];
    const selectedAsl = this.asls.find((asl) => asl.id == this.selectedAslId);
    if (!selectedAsl) return;

    if (this.cot) {
      selectedAsl.cots.forEach((c) =>
        this.ownerships.push({ ...c, type: 'COT', actorId: 2 })
      );
    }

    if (this.uvm) {
      selectedAsl.uvmTypes.forEach((u) =>
        this.ownerships.push({ ...u, type: 'UVM', actorId: 1 })
      );
    }

    if (this.ward) {
      selectedAsl.wards.forEach((w) =>
        this.ownerships.push({ ...w, type: 'REPARTO', actorId: 3 })
      );
    }

    this.filterOwnerships();
  }

  filterOwnerships(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredOwnerships = this.ownerships.filter(
      (item) =>
        item.name.toLowerCase().includes(term) ||
        item.type.toLowerCase().includes(term)
    );
  }

  resetFilter(): void {
    this.searchTerm = '';
    this.filterOwnerships();
  }

  selectOwnership(ownership: any): void {
    this.selectedOwnershipId = ownership;
  }

  confirm(): void {
    if (this.selectedOwnershipId) {
      this.changeConfirmed.emit({
        actorId: this.selectedOwnershipId.actorId.toString(),
        ownershipId: this.selectedOwnershipId.id.toString(),
      });
    }
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
